export default __webpack_public_path__ + "static/hotblack-events4-ac61f6d106b46fa98b9d810cf9f1ecc4.jpg";